import React, { useEffect, useState } from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LanguageIcon from '@mui/icons-material/Language';
import './index.css';

export default function RedesSociales() {
    const [redes, setRedes] = useState<{ name: string, link: string, active: boolean }[]>([])

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setRedes(config.REDES_SOCIALES)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {redes.length > 0 &&
                <div className="redes-sociales">
                    {redes[0].active &&
                        <a className='link' href={redes[0].link}>
                            <XIcon sx={{ color: 'white', width: '20px' }} />
                        </a>
                    }
                    {redes[1].active &&
                        <a className='link' href={redes[1].link}>
                            <FacebookIcon sx={{ color: 'white', width: '20px' }} />
                        </a>
                    }
                    {redes[2].active &&
                        <a className='link' href={redes[2].link}>
                            <LanguageIcon sx={{ color: 'white', width: '20px' }} />
                        </a>
                    }
                </div>
            }
        </>
    );
}
